/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tab from "vux/src/components/tab/tab.vue"; // this line is trasformed by vux-loader
import TabItem from "vux/src/components/tab/tab-item.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Divider from "vux/src/components/divider/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Flexbox from "vux/src/components/flexbox/flexbox.vue"; // this line is trasformed by vux-loader
import FlexboxItem from "vux/src/components/flexbox/flexbox-item.vue"; // this line is trasformed by vux-loader
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import Swiper from "vux/src/components/swiper/swiper.vue"; // this line is trasformed by vux-loader
import SwiperItem from "vux/src/components/swiper/swiper-item.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import { apicorporation, apiGetMatchQrServiceList, apicorporationdata, getIdByQRCode, apisystemsettingByCode, apisystemsettingloginByCode, getCustomerProductDetail, getCustomerProductGetService } from '@/api';
import { mapMutations, mapState } from 'vuex';
import ScrollerList from '@/components/ScrollerList';
import OrderItem from '@/components/ScrollerList/OrderItem';
import ExtFieldPc from '@/components/ExtFieldPc';
export default {
  name: 'Product',
  props: {
    code: {
      type: String,
      default: ''
    }
  },
  components: {
    Tab: Tab,
    TabItem: TabItem,
    Group: Group,
    Divider: Divider,
    XButton: XButton,
    Flexbox: Flexbox,
    FlexboxItem: FlexboxItem,
    ScrollerList: ScrollerList,
    OrderItem: OrderItem,
    ExtFieldPc: ExtFieldPc,
    Popup: Popup,
    Swiper: Swiper,
    SwiperItem: SwiperItem,
    ViewBox: ViewBox
  },
  data: function data() {
    return {
      tabsIndex: 0,
      isShowLogo: '',
      isShowHistoryOrder: 0,
      // 客户信息
      extFields: [],
      corporationdata: {},
      // 添加信息
      adddata: [],
      falg: true,
      unfalg: false,
      sharefalg: false,
      corporationdataunfalgs: [],
      pageIndex: 0,
      pageSize: 10,
      ids: {
        pId: '',
        cId: '',
        cpId: ''
      },
      searchFormFormat: {},
      customerProductDetail: {
        fvs: [],
        customerPro: {}
      },
      codeMap: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['enterprise'])), {}, {
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 14.2 * fontSize;
    },
    style: function style() {
      return this.isShowLogo ? {
        backgroundImage: "url(".concat(this.isShowLogo, ")")
      } : {};
    }
  }),
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var ids, pId;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.loadSet();
            case 2:
              _context.next = 4;
              return getIdByQRCode({
                code: _this.code
              });
            case 4:
              ids = _context.sent;
              if (ids.success && ids) {
                _this.ids = ids.data;
                pId = ids.data.pId;
                apicorporation({
                  productId: pId
                }).then(function (res) {
                  if (res.success) {
                    _this.corporationdata = res.data.productMap || {};
                    _this.extFields = res.data.list || [];
                  }
                });
                apiGetMatchQrServiceList({
                  customerProductionId: _this.ids.cpId
                }).then(function (res) {
                  if (res.success) {
                    _this.adddata = res.data;
                  }
                });
                if (_this.isShowHistoryOrder) {
                  _this.loadList(true);
                }
                if (_this.ids.cpId) {
                  getCustomerProductDetail({
                    customerProductionId: _this.ids.cpId
                  }).then(function (res) {
                    if (res.success) {
                      _this.customerProductDetail = res.data;
                    }
                  });
                  try {
                    getCustomerProductGetService().then(function (res) {
                      if (res.success) {
                        res.data.forEach(function (val) {
                          _this.$set(_this.codeMap, val.code, val.value);
                        });
                      }
                    });
                  } catch (error) {
                    console.log('AutoConsole: created -> error', error);
                  }
                }
              } else {
                _this.$vux.toast.text(ids.message);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_showHomebottomBar', '_pageReload'])), {}, {
    handleJump: function handleJump(item) {
      this.$router.push({
        name: 'ProjectDetail',
        params: {
          oid: item.orderId
        }
      });
    },
    sharecancel: function sharecancel() {
      this.sharefalg = false;
    },
    // 添加请求数据
    shareshow: function shareshow() {
      if (this.adddata.length === 0) {
        this.$vux.toast.text(i18n.tc("499"));
      } else {
        this.sharefalg = true;
      }
    },
    loadList: function loadList() {
      var _this2 = this;
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var operation = arguments.length > 1 ? arguments[1] : undefined;
      if (reset) {
        this.pageIndex = 0;
        this.$vux.loading.show({
          text: i18n.tc("206")
        });
      }
      return new Promise(function (resolve, reject) {
        var data = {
          pageIndex: _this2.pageIndex,
          pageSize: _this2.pageSize,
          customerProductionId: _this2.ids.cpId
        };
        apicorporationdata(data).then(function (res) {
          if (!res.success) return;
          // 不重置数据累计
          if (!reset) {
            _this2.corporationdataunfalgs = Object.freeze([].concat(_toConsumableArray(_this2.corporationdataunfalgs), _toConsumableArray(res.data)));
          } else {
            _this2.corporationdataunfalgs = Object.freeze(res.data);
            setTimeout(function () {
              _this2.$vux.loading.hide();
            }, 300);
          }
          resolve();
          // 判断是否有新数据
          if (res.data.length < _this2.pageSize) {
            setTimeout(function () {
              _this2.$refs['corporationdataunfalgs'] && _this2.$refs['corporationdataunfalgs'].disablePullup();
            }, 100);
          }
          if (res.data.length === _this2.pageSize) {
            setTimeout(function () {
              _this2.$refs['corporationdataunfalgs'] && _this2.$refs['corporationdataunfalgs'].enablePullup();
            }, 100);
          }
        });
      });
    },
    // 下拉刷新
    onPulldownLoading: function onPulldownLoading() {
      var _this3 = this;
      this.loadList(true).then(function () {
        _this3.$refs['corporationdataunfalgs'] && _this3.$refs['corporationdataunfalgs'].donePulldown();
      });
    },
    // 上拉加载
    onPullupLoading: function onPullupLoading() {
      var _this4 = this;
      this.pageIndex = this.pageIndex + 1;
      this.loadList().then(function () {
        _this4.$refs['corporationdataunfalgs'] && _this4.$refs['corporationdataunfalgs'].donePullup();
      });
    },
    loadSet: function loadSet() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return apisystemsettingByCode({
                  code: 40007
                }).then(function (res) {
                  if (res.success) {
                    _this5.isShowHistoryOrder = +res.data.value;
                  }
                });
              case 2:
                _context2.next = 4;
                return apisystemsettingloginByCode({
                  code: _this5.code
                }).then(function (res) {
                  if (res.success && res.data) {
                    _this5.isShowLogo = res.data.img_url ? res.data.img_url : i18n.tc("500");
                  }
                });
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  })
};